export function translateBillName(name, i18n) {
    switch (name) {
        case 'MONTH-BILL-FOOD-COST':
            return i18n('LABEL_MEALS')
        case 'MONTH-BILL-PRESENCE-COST':
            return i18n('LABEL_GRANT__PERCENTAGE_PRESENCE')
        case 'MONTH-NOTE-COST':
            return i18n('LABEL_ADDITIONAL_COSTS')
        case 'MONTH-BILL-PRESENCE-COST-UPFRONT':
            return i18n('LABEL_PAYMENT_UPFRONT')
        case 'MONTH-BILL-FOOD-COST-UPFRONT':
            return i18n('LABEL_MEALS_UPFRONT')
        case 'MONTH-BILL-FOOD-BALANCE':
            return i18n('LABEL_FOOD_BALANCE')
        case 'MONTH-BILL-PRESENCE-BALANCE':
            return i18n('LABEL_PAYMENT_BALANCE')
        case 'MONTH-BILL-PRESENCE-COST-EXTRA':
            return i18n('LABEL_ADDITIONAL_PRESENCE_COST')
        case 'MONTH-BILL-NOTE-COST':
            return i18n('BILL_NOTE_COST')
        case 'MONTH-BILL-TIMETABLE-COST':
            return i18n('BILL_TIMETABLE_EVENT_COST')
        case 'MONTH-BILL-NOTE-BALANCE':
            return i18n('NOTES_BALANCE')
        case 'MONTH-BILL-TIMETABLE-BALANCE':
            return i18n('PAID_TIMETABLE_EVENTS_BALANCE')
        default:
            return name
    }
}
